/**
 * Load dayjs plugins here
 * https://day.js.org/docs/en/plugin/loading-into-nodejs
 */

import dayjs from 'dayjs';
import RelativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(RelativeTime);
